import { Box, Text } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const ItemLink = ({ to = null, children, ...props }) => {
  const { colorMode } = useColorMode()
  const themeColorFontEmpty = colorMode === 'light' ? 'gray.400' : 'gray.600'
  const themeColorFontHover = colorMode === 'light' ? 'blue.400' : 'blue.300'
  return (
    <Box
      display="flex"
      alignItems="center"
      transition="0.3s"
      whiteSpace="nowrap"
      overflow="hidden"
      position="relative"
      _groupHover={{
        color: themeColorFontHover,
      }}
      {...props}
    >
      {to ? (
        <Link to={to}>
          {children ? children : <Text color={themeColorFontEmpty}>Нет данных</Text>}
        </Link>
      ) : (
        <Box>{children ? children : <Text color={themeColorFontEmpty}>Нет данных</Text>}</Box>
      )}
    </Box>
  )
}
